import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectInput from '../../../../Core/Fields/SelectInput';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ supplier, setSelectedSupplier, selectedSupplier, setSuppliergrpname, supplirGrpname, payment, setIsGroup, isGroup, setSelectedpayment, selectedpayment }) => {

  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>
      <div className='d-flex mx-2'>
        <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <Input
                id="BrandName"
                label="Supplier Group Name"
                style={{ height: "30px" }}
                value={supplirGrpname}
                onChange={(e) => setSuppliergrpname(e.target.value)}
              />
            </div>
          </div>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <SelectSearch
                list={supplier || []}
                label="Parent Supplier Group"
                value={selectedSupplier}
                onChange={(val) => setSelectedSupplier(val)}

                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
              />

            </div>
          </div>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <SelectSearch
                list={payment || []}
                label="Default Payment Terms Template"
                value={selectedpayment}
                onChange={(val) => setSelectedpayment(val)}
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                placeholder=""
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px', marginLeft: '5px' }} >
        <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400px', marginBottom: '18px' }}>
          <input
            type="checkbox"
            style={{ width: '12px', height: '12px' }}
            checked={isGroup === 1}
            onChange={(e) => setIsGroup(e.target.checked ? 1 : 0)}
            className="form-check-input me-1 mt-1"

          />
          Is Group
        </label>
      </div>
    </div>
  )
}

export default Tab1